import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import  { homeRoutes } from "../../routes";
import { withRouter } from "react-router-dom";
import ButtonHeaderDesktop from "../ButtonHeaderDesktop";
import ButtonHeaderMobile from "../ButtonHeaderMobile";
import ButtonHeaderDropDown from "../ButtonHeaderDropDown";

import * as authTypes from "../../redux/types/auth.js";
import { useDispatch, useSelector } from "react-redux";
import logoHeader from "../../assets/logoHeader.png";
import "./styles.scss";
import { actionLogoutUser } from "../../redux/actions/auth";
import { Auth } from "aws-amplify";
import { getLocalStorage, removeLocalStorage } from "../../utils/LocalStorage";
import { isEmpty } from "../../utils/utils";

// let user = getLocalStorage("user");
// console.log("🚀 ~ file: index.jsx ~ line 19 ~ Header ~ user", user);

const Header = ({ history, location }) => {
  const [isLogin, setIsLogin] = useState(false);
  const [username, setUsername] = useState("");
  const  [roleRoute, setRoleRoute] = useState([]);
  const dispatch = useDispatch();

  useEffect(async () => {
    console.log("Location:",location)
    if(location.pathname.indexOf('/home/proveedores/token/')!=-1){
      return true;
    }
    let user = getLocalStorage("user");
    let isAuthenticate = isEmpty(user) ? false : true;
    setIsLogin(isAuthenticate);
    const currentUser = await Auth.currentAuthenticatedUser();
    setUsername(currentUser?.attributes["name"] || currentUser?.attributes["nombre"] || currentUser?.attributes["email"]||  user?.username);

    const typeUser = currentUser?.attributes["custom:type_user"];  
    const roleUser = currentUser?.signInUserSession.accessToken.payload["cognito:groups"];
    const roleAdmin  = roleUser && roleUser.filter(role => role == process.env.REACT_APP_ROLE_ADMIN) || "";
    let routesTest;
    let routesConcat=[];
    if(roleAdmin.length > 0 && roleAdmin[0] == process.env.REACT_APP_ROLE_ADMIN){
      routesTest = homeRoutes.filter(el => el.showIntoMenu) 
      setRoleRoute(routesTest)
    }else{          
        for (const roleItem of roleUser) {
          routesTest = null;
          if(roleItem == process.env.REACT_APP_ROLE_CARGA){
            routesTest = homeRoutes.filter(el => el.id == 13)
            routesTest.filter(el=>el.id==13)[0].items =  homeRoutes.filter(el=>el.id==13)[0].items.filter(el=>(el.id == 131 || el.id == 132 || (el.id == 133 && typeUser !=='provider')));            
          }
          if(roleItem == process.env.REACT_APP_ROLE_CONSULTA){
            routesTest = homeRoutes.filter(el => el.id == 13 || el.id == 5);
            routesTest.filter(el=>el.id==13)[0].items =  homeRoutes.filter(el=>el.id==13)[0].items.filter(el=>(el.id == 131 || (el.id == 133 && typeUser !=='provider')));             
          }
          if (roleItem == process.env.REACT_APP_ROLE_TRIBUTACION) {
            routesTest = homeRoutes.filter(el => el.id == 13 || el.id == 12) 
            routesTest.filter(el=>el.id==12)[0].items =  homeRoutes.filter(el=>el.id==12)[0].items.filter(el=>el.id == 123);                   
            routesTest.filter(el=>el.id==13)[0].items =  homeRoutes.filter(el=>el.id==13)[0].items.filter(el=>(el.id == 131 || el.id == 132 || (el.id == 133 && typeUser !=='provider')));            
          }
          if(routesTest && routesTest.length > 0)
            routesConcat = routesConcat.concat(routesTest);
        }
        routesTest = unique(routesConcat);
        setRoleRoute(routesTest)         
    }

    return { typeUser};
  }, [location.pathname]);

  const unique = (array) => {    
    var a = array.concat();
    for(var i=0; i<a.length; ++i) {
        for(var j=i+1; j<a.length; ++j) {
            if(a[i].id === a[j].id)
                a.splice(j--, 1);
        }
  }  
    return a;  
}

  const handleRoute = (path) => {
    history.push(path);
  };

  const handleLogout = async () => {
    dispatch(actionLogoutUser());
    removeLocalStorage("user");
    await Auth.signOut();
    history.push("/login");
  };

  const itemMenu = (role) => {
    return (
      <>
        {role
          .filter((homeItem) => homeItem.showIntoMenu)
          .map((homeItem) => {
            if (homeItem.type === "dropdown") {
              return (
                <ButtonHeaderDropDown
                  items={homeItem.items}
                  name={homeItem.name}
                  handleRoute={handleRoute}
                />
              );
            } else {
              return (
                <p
                  key={homeItem.id}
                  className="header-text header-text-red"
                  onClick={() => handleRoute(homeItem.path)}
                >
                  {homeItem.name}
                </p>
              );
            }
          })}
      </>
    );
  };

  return (
    <header className="header-wrapper d-align-center d-justify-center bg-red">
      <div className="header-content d-align-center">
        <img src={logoHeader} alt="logo header" />
        {isLogin && (
          <>
            <div className="header-menu--desktop d-align-center w100">
              {itemMenu(roleRoute)}
              <ButtonHeaderDesktop
                username={username}
                handleLogout={handleLogout}
              />
            </div>
            <div className="header-menu--mobile d-flex-end--mobile w100">
              <ButtonHeaderMobile
                listMenu={roleRoute}
                handleRoute={handleRoute}
                handleLogout={handleLogout}
              />
            </div>
          </>
        )}
      </div>
    </header>
  );
};

Header.defaultProps = {
  // isLogin: false,
  // username: "PFigueroa",
};

Header.propTypes = {
  // isLogin: PropTypes.bool,
  // username: PropTypes.string,
};

export default withRouter(Header);
